<template>
  <div class="msgTxt bg-white p-3">
     <vs-row vs-justify="flex-end">
      <span v-if="message.message_time" style="width:100%;font-size:10px;">{{message.sender_user_details.first_name}} {{message.sender_user_details.last_name}} &nbsp; {{ message.message_time | moment('h:mm a') }}</span>
    </vs-row>
    <vs-row>
      <div style="white-space: pre-line"> {{ message.message }}</div>
    </vs-row>
   
  </div>
</template>
<script>
import {messageMixin} from './mixin/messageMixin'
import {mapGetters} from 'vuex'

export default {
  name: 'messageTextContainer',
  props:  {
    message: {
      type:Object,
      required:true,
      default:() => {}
    }
  },
  data () {
    return {
    }
  },
  mixin:[messageMixin],
  computed: {
    ...mapGetters(['UserActiveThread', 'ClientActiveThread', 'GroupActiveThread', 'tabActive'])
  },
  mounted () {
    
  },
  methods: {
    

  }
}
</script>
<style scoped>
.msgTxt {
  position: relative;
  min-height:50px;
  max-width:70%;
  min-width:10%;
  border-radius: 10px;
}

.delete-msg{
  position: absolute;
  top: 26px;
  right: -30px;
}
</style>
